import React, { useState } from 'react';
import { VStack, Span, } from '@bpba/ui-components';
import {  useForm } from 'react-hook-form';
import { Localidad } from '../rest/models/Localidad';
import { Sucursal } from '../rest/models/Sucursal';
import { Partido } from '../rest/models/Partido';
import { useQuery } from "@apollo/client";
import { Queries } from "../rest/Queries";
import { getLocalidadesSuc } from '../rest/queries/getLocalidadesSuc';
import { getSucursales } from '../rest/queries/getSucursales';
import { getPartidosSuc } from '../rest/queries/getPartidosSuc';

import { getDetalleSucursalUbicom } from '../rest/queries/getDetalleSucursalUbicom';

type Props = {
    titulo: string
    sucursalCliente?:number
    onChangeValue: (opcionElegida: any) => void;
  };


const ComboSucursales: React.FC<Props> =( {titulo, sucursalCliente, onChangeValue} : Props) => {

 
    const REQUIRED_FIELD = "Campo requerido.";
    
    const [idProvinciaSuc, setIdProvinciaSuc] = useState<string>();
    const [idLocalidadSuc, setIdLocalidadSuc] = useState<string>();
    const [idPartidoSuc, setIdPartidoSuc] = useState<string>();
    const { data: { localidadesSuc } = {} } = useQuery<Queries>(getLocalidadesSuc, { variables: { idPartido: idPartidoSuc }, skip: !idPartidoSuc });
    const { data: { partidosSuc } = {} } = useQuery<Queries>(getPartidosSuc, { variables: { idProvincia: idProvinciaSuc }, skip: !idProvinciaSuc });
    const { data: { sucursales } = {} } = useQuery<Queries>(getSucursales, { variables: { idLocalidadSuc: idLocalidadSuc, filterBranch: 1 }, skip: !idLocalidadSuc });

    
    

    const { register, resetField, formState: { errors } } = useForm<any>({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onChange',
        defaultValues: {
            sucursal: ""
        }
    });

    const { data: { detalleSucursalUbicom } = {} } = useQuery<Queries>(getDetalleSucursalUbicom, { variables: { ubicom: sucursalCliente }, skip: !sucursalCliente });


   

    function BuscPartidosSuc(formId: string) {
        setIdProvinciaSuc(formId.split('-')[0]);
        setIdPartidoSuc('');
        setIdLocalidadSuc('');
        resetField('localidadSuc');
        resetField('sucursal');

    }

    function BuscLocSuc(formId: string) {
        setIdPartidoSuc(formId.split('-')[0]);
        if (formId === '') {
            setIdLocalidadSuc('');

        }
        resetField('localidadSuc');
        resetField('sucursal');
    }

    function BuscSuc(formId: string) {
        setIdLocalidadSuc(formId.split('-')[0]);
        resetField('sucursal');
    }


    return (

        <VStack mt={"20px"}>

            <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>{titulo ? titulo : "Sucursal"}</Span>
            {!sucursalCliente ?

                (<>
                    <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                        <VStack mr={"0.5rem"}>
                            <select tabIndex={0} aria-label={"Seleccione la provincia para la localidad de la  sucursal"}
                                {...register("provinciaSuc", { required: REQUIRED_FIELD })}
                                onChange={(e) =>  BuscPartidosSuc(e.target.value)} name="provinciaSuc" >
                                <option value="" >Ubicación</option>
                                <option value="2-Buenos Aires">Buenos Aires</option>
                                <option value="1-Ciudad de Buenos Aires">Ciudad de Buenos Aires</option>
                            </select>

                            <Span color="red" fontSize={"12px"} tabIndex={0}>
                                {errors.provinciaSuc ? "* " + errors.provinciaSuc.message : ""}
                            </Span>
                        </VStack>
                        <VStack>
                            <select tabIndex={0} aria-label={"Seleccione el partido de la  sucursal"} {...register("partidoSuc", { required: REQUIRED_FIELD })} onChange={(e) =>  BuscLocSuc(e.target.value)} name="partidoSuc" 
                            >
                                <option value="" >Partido</option>
                                {partidosSuc &&
                                    partidosSuc.map((item: Partido) =>
                                        <option value={item.id_partido} key={item.desc_partido}>{item.desc_partido}</option>
                                    )}
                            </select>
                            <Span color="red" fontSize={"12px"} tabIndex={0}>
                                {errors.partidoSuc ? "* " + errors.partidoSuc.message : ""}
                            </Span>
                        </VStack>
                    </VStack>
                    <VStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                        <VStack mr={"0.5rem"}>
                            <select tabIndex={0} aria-label={"Seleccione la localidad de la  sucursal"} {...register("localidadSuc", { required: REQUIRED_FIELD })} onChange={(e) =>  BuscSuc(e.target.value)} name="localidadSuc" 
                            >
                                <option value="" >Localidad/barrio</option>
                                {localidadesSuc &&
                                    localidadesSuc.map((item: Localidad) =>
                                        <option value={item.id_localidad} key={item.desc_localidad}>{item.desc_localidad}</option>
                                    )}
                            </select>

                            <Span color="red" fontSize={"12px"} tabIndex={0}>
                                {errors.localidadSuc ? "* " + errors.localidadSuc.message : ""}
                            </Span>
                        </VStack>
                        <VStack>
                            <select tabIndex={0} aria-label={"Seleccione la  sucursal"} style={{ width: "100%" }} {...register("sucursal", { required: REQUIRED_FIELD })} name="sucursal" onChange={(e) => onChangeValue(e)} >
                                <option value="" disabled>Sucursal</option>
                                {sucursales &&
                                    sucursales.map((item: Sucursal) =>
                                        <option value={item.cod_ubic} key={item.suc_nombre}>{item.cod_ubic + " - " + item.suc_nombre}</option>
                                    )}
                            </select>
                            <Span color="red" fontSize={"12px"} tabIndex={0}>
                                {errors.sucursal ? "* " + errors.sucursal.message : ""}
                            </Span>
                        </VStack>
                    </VStack>
                </>) : (
                    <VStack >
                        <Span mb={"8px"} fontSize={"14px"} style={{ width: "100%", height: '2.5em' }} tabIndex={0}>{sucursalCliente}- {detalleSucursalUbicom?.suc_nombre} - {detalleSucursalUbicom?.domicilio}</Span>

                    </VStack>
                )}

        </VStack>
    )

};

export default ComboSucursales;